import { render, staticRenderFns } from "./koraDocumentDetail.vue?vue&type=template&id=57586d50"
import script from "./koraDocumentDetail.vue?vue&type=script&lang=js"
export * from "./koraDocumentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57586d50')) {
      api.createRecord('57586d50', component.options)
    } else {
      api.reload('57586d50', component.options)
    }
    module.hot.accept("./koraDocumentDetail.vue?vue&type=template&id=57586d50", function () {
      api.rerender('57586d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/kora/koraDocumentDetail.vue"
export default component.exports